<template>
<div>
	<div class="padding-1-left"> <h3>{{session_list.name}}</h3>
	</div>

	<div class="padding-1 flex">
		<div class="lesson-section">
			<label>Preferred language</label>
				<multiselect
					v-model="current_language"
					label="name"
					@input="getSessionsPlayer"
					:options="preferred_languages">
				</multiselect>
			<label>Lesson List</label>
			
				<div v-for="(module, index) in session_list.modules"
				:key="module.id">
					<div class="module-box mb-2" :class="{'gray-background' : isOpen.includes(index)}">
						<div  role="tablist">
							<a class="pointer"  @click="collapseModule(index)" >
								<div class="display-flex-row font-16">
									{{ module.name }}

									<img id="" :class="{'transform-180': isOpen.includes(index)}" 
									class="img-font-size mt-1 float-right" src="../../assets/images/keyboard_arrow_down_u50.svg"/>
								</div>
							</a>
						</div>
					</div>
					<div v-show="isOpen.includes(index)" class="module-detail">
						<div v-for="lesson in module.lessons" :key="lesson.id">
							<div class="lesson-box flex mb-3" :class="{'active_lesson': current_lesson.id == lesson.id}">
								<a class="cursor flex" @click="openLesson(lesson)">
									<span v-if="lesson.progress.completed_at" class="session_view_icon approved"></span>
									<img v-else-if="lesson.progress.status == 'Started'" class="max-height-icon" src="../../assets/images/icons/solid/session_progress.svg"/>
									<img v-else class="max-height-icon" src="../../assets/images/icons/solid/play-circle.svg"/>
									<section>{{lesson.name}}</section>
								</a>
							</div>
						</div>
					</div>
				</div>
		</div>

		<div class="frame_iframe">
			<div v-show= "tincan_url === null" class="center-text">
				<h4 style="text-align: center">Select a Lesson to Play</h4>
			</div>
			<iframe  scrolling="no" id="tincan_frame"  height="100%" width="100%" frameborder="0" v-if="tincan_url" class="embed-responsive-item"  ref="iframe" :src="tincan_url" allowfullscreen :name="Date.now()">
			</iframe>
			<button class="button green_content_session_view iphone-fullscreen-exit" @click="allowFullScreen()"></button>
		</div>

	</div>
	</div>
</template>
<script>
export default {
	data : function(){
		return{
			tincan_url: null,
			session_list:'',
			current_lesson:null,
			index_: 0,
			preferred_languages: [],
			current_language:{
				code_2:'EN',
				name:'English'
			},
			hide_resume_button: false,
			isOpen: [],
		}
	},
	computed : {
		router_origin(){
			if(this.$store.getters.getRole == 'csm'){
				return 'admin'
			}else{
				return 'organization'
			}
		},
		getFrame(){
			return this.$refs.iframe
		}
	},
	created : function() {
		this.getSessionsPlayer()
		//this.getPreferredLanguages()
	},
	mounted: function(){
		window.addEventListener('message', (event) => {
			if(event.data.type == 'tincan_event'){
				if(event.data.verb == 'completed' || event.data.verb == 'passed'){
					if(event.data.lesson_id){
						this.markLessonAsCompleted(event.data.lesson_id)
					}
				}
			}
		});
	},
	methods : {
		collapseModule(index) {
			if (this.isOpen.includes(index)) {
				this.isOpen = this.isOpen.filter(i => i !== index);
				return;
			}
			this.isOpen.push(index);
		},
		openLesson(elem){
			this.$nextTick(() => {
				if(elem){
					this.current_lesson = elem
					this.tincan_url = elem.tincan_url+'&os=web&random=' + Math.random()
				}else{
					this.tincan_url = 	this.current_lesson.tincan_url+'&os=web&random=' + Math.random()
					this.current_lesson
				}
				this.hide_resume_button = true
			})
		},
		getSessionsPlayer(){
			var params = {
				id: this.$route.params.session_id,
				filters:{
					full : true,
					language: this.current_language.code_2,
					progress: true,
					// organization_id: 16
				}
			}
			if(this.router_origin == 'admin'){
				params.filters.organization_id = this.$route.params.agency_id
			}
			this.$store.dispatch('getSessionsPlayer', params).then((res) => {
				this.$nextTick(() => {
					this.session_list = res.data.data
					this.preferred_languages = res.data.data.languages
					// if(this.preferred_languages && this.preferred_languages.length>0){
					// 	this.current_language = this.preferred_languages[0]
					// }
					// this.getPreferredLanguages(res.data.data.languages)
					this.current_lesson = this.session_list.modules[0].lessons[0];
				})
				this.$forceUpdate();


			}).catch((error) => {
				console.log(error.resolve)
			})

			// http://localhost:8085/in-class-app/sessions/2/course?full=true&language=ES&progress=true&organization_id=16'
		},
		// getPreferredLanguages : function(){
		// 	this.preferred_languages = []
		// 	var params = { filters:{available_for_users: 1} };
		// 	this.$store.dispatch('getLanguages', params).then((res) => {
		// 		for(let i in res.data.data){
		// 			// if(this.provider_data.language == res.data.data[i][0].code_2){
		// 			// 	this.provider_data.language = {key:res.data.data[i][0].code_2, value:res.data.data[i][0].name}
		// 			// }
		// 			this.preferred_languages.push({key:res.data.data[i][0].code_2, value:res.data.data[i][0].name})
		// 		}
		// 	}).catch((error) => {
		// 		console.log(error);
		// 	});
		// },
		allowFullScreen: function(){

			var elem = this.$refs['iframe'];
			if (elem.webkitEnterFullScreen) {
				elem.webkitEnterFullScreen();
				}
			else if (elem.requestFullscreen) {
				elem.requestFullscreen();
				} else if (elem.mozRequestFullScreen) { /* Firefox */
				elem.mozRequestFullScreen();
				} else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
				elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) { /* IE/Edge */
				elem.msRequestFullscreen();
				}else{
					// this.iphone_full_screen = !this.iphone_full_screen
				}
		},
		markLessonAsCompleted(id){
			this.session_list.lessons.map(elem => {
			if(elem.id == id){
				elem.progress.completed_at = true
			}
			})
		}
	}
}
</script>
<style>
.module-box{
	position: relative;
	cursor: pointer;
    padding: 1rem;
    border: 2px solid #ddd;
    line-height: 2em;
	font-weight: 500;
	font-size: 18px;
}

.gray-background{
	background-color: rgba(242, 242, 242, 1) !important;
}

.transform-180{
	transform: rotate(180deg);
}

.center-text {
	margin: auto;
	padding-top: 110px;
}

.lesson-arrange {
	display: flex;
	flex-flow: row;
	gap: 12px;
}
.lesson-box{
	position: relative;
	cursor: pointer;
    padding: 0.8rem;
    border: 1px solid #ddd;
    border-radius: 0;
    line-height: 1.3em;
	border-radius: 8px;
}
.lesson-box > a{
	font-weight: 500;
	font-size: 18px;
}
.max-height-icon{
	max-height: 25px;
	min-height: 25px;
	min-width: 25px;
	max-width: 25px;
}
.lesson-section{
	width: 30%;
	display: flex;
    flex-flow: column;
    gap: 0.7rem;
}
.lesson-box .flex{
	gap: 1rem;
}
.lesson-box > a{
	align-items: center;
}
.padding-1{
	padding: 1rem;
}
.padding-1-left{
	padding-left: 1rem;
}
.active_lesson{
    background-color: #20a6a7;
    color: #fff;
}
.frame_iframe{
	width: -moz-available;
	min-height: -moz-available;
	width: -webkit-fill-available;
    min-height: -webkit-fill-available;
	padding: 0rem 1rem;
	display: block;
	position: relative;
}
iframe{
	width: -webkit-fill-available;
	height: -webkit-fill-available;
	min-height:80vh;
}
.remuse_button_tincan{
    position: relative;
    right: -42%;
    top: -60%;
    background-color: #215052;
    font-size: 23px;
}
.green_content_session_view{
	background-color: #215052;
	color: #ffffff;
	position: absolute;
	right: 16px;
	top: 0px;
	background-image: url(../../assets/images/icons/solid/icon_expand_white.svg);
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 60%;
	font-size: 0;
	width: 40px;
	height: 40px;
	border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/sessionPlayerView.vue